export function deleteCookies() {
  const [, utmSourceValue] = window.location.search
    .split('&')
    .filter((param) => param.includes('utm_source'))
    .join('')
    .split('=')

  if (utmSourceValue === 'econtact') {
    const cookies = document.cookie.split('; ')

    cookies
      .map((cookie) => cookie.split('='))
      .forEach(([cookieName]) => {
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
      })

    setTimeout(() => {
      location.reload()
    }, 3000)
  }
}
